import { EstatePaymentStatus } from '@/modules/estate/constants/EstatePaymentStatus';
import { BaseWorkflowRule } from '@/modules/workflow/models/BaseWorkflowRule';

export class WorkflowPaymentStatusRule extends BaseWorkflowRule {
  id?: number;

  paymentStatus?: string;

  constructor(model: Partial<WorkflowPaymentStatusRule> = {}) {
    super(model);

    this.id = model.id;
    this.paymentStatus = model.paymentStatus;
  }

  get ruleId(): string | undefined {
    return this.paymentStatus;
  }

  toString(): string {
    return EstatePaymentStatus.getByKey(this.paymentStatus).value;
  }
}
